import {$t} from "../../../helpers/translator";
import Menu from "../../../components/miscellaneous/Menu/Menu";
import {FaUsers, FaClinicMedical, FaChartBar, FaUserMd, FaBookMedical, FaTools, FaFileAlt, FaCog} from 'react-icons/fa';
import machineWhite from '../../../assets/alma-icons/machineWhite.png'
import handleWhite from '../../../assets/alma-icons/handleWhite.png'

const ChainMenu = () => {
    const items = [
        {name: $t('global.menu.dashboard'), icon: <FaChartBar />, path: '/', pathIncludes: '/dashboard'},
        {name: $t('global.menu.clinics'), icon: <FaClinicMedical />, path: '/clinics', pathIncludes: '/clinic/'},
        {name: $t('global.menu.patients'), icon: <FaUsers />, path: '/patients', pathIncludes: '/patient/'},
        {name: $t('global.menu.staff'), icon: <FaUserMd />, path: '/staff', pathIncludes: '/staff/'},
        {name: $t('global.menu.treatments'), icon: <FaBookMedical />, path: '/treatments', pathIncludes: '/treatments/'},
        {name: $t('global.menu.equipment'), icon: <FaCog />, path: null, children: [
            {name: $t('global.menu.platforms'), icon: machineWhite, path: '/equipment/platforms', pathIncludes: '/platform/'},
            {name: $t('global.menu.applicators'), icon: handleWhite, path: '/equipment/applicators', pathIncludes: '/applicator/'},
        ]},
        {name: $t('global.menu.reports'), icon: <FaFileAlt />, path: '/reports', pathIncludes: '/report/'},
        {name: $t('global.menu.service'), icon: <FaTools />, path: '/service', exact: true},
    ]

    return (
        <Menu items={items} userType={3} />
    )
};

export default ChainMenu;
